"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _underscore = _interopRequireDefault(require("underscore"));

var _BaseCustomizationParser = _interopRequireDefault(require("./BaseCustomizationParser"));

var _Migration = _interopRequireDefault(require("../Migration"));

var _atomProps = _interopRequireDefault(require("./atomProps"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

var migration = new _Migration.default(); // Once customization data structure is decided to be changed, add a migration:
// migration.add({
//     targetVersion: 2,
//     migrate(input) {
//         return input;
//     }
// });

var EMPTY = {
  version: migration.version,
  data: undefined
};
var PLAIN_PROPS = ['fontId', 'fontType', 'fontBold', 'fontItalic', 'fontUnderline', 'fontSize', 'letterSpacing', 'topSpacing', 'bottomSpacing', 'lineHeight', 'width', 'height', 'borderWidth', 'borderRadius', 'backgroundSize', 'backgroundRepeat', 'backgroundPosition', 'backgroundAttachment'];

var ElementCustomizationParser = /*#__PURE__*/function (_BaseCustomizationPar) {
  _inherits(ElementCustomizationParser, _BaseCustomizationPar);

  var _super = _createSuper(ElementCustomizationParser);

  function ElementCustomizationParser() {
    _classCallCheck(this, ElementCustomizationParser);

    return _super.apply(this, arguments);
  }

  _createClass(ElementCustomizationParser, [{
    key: "empty",
    value: function empty() {
      return EMPTY;
    }
  }, {
    key: "migrate",
    value: function migrate(input) {
      return migration.migrate(input);
    }
  }, {
    key: "refine",
    value: function refine(input) {
      var plainProperties = _underscore.default.pick(input, PLAIN_PROPS);

      var atomProperties = _underscore.default.chain(input).omit(PLAIN_PROPS).map(function (atom, key) {
        return [key, _underscore.default.pick(atom, _atomProps.default)];
      }).object().value();

      return _objectSpread(_objectSpread({}, plainProperties), atomProperties);
    }
  }]);

  return ElementCustomizationParser;
}(_BaseCustomizationParser.default);

exports.default = ElementCustomizationParser;